export class Water {
  type = "water";
  amount = Infinity;
  isObstacle = true;
}